import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <div className="app-layout">
      <Header />
      <main className="main-content">
        {/* Render nested route components here */}
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;



